import { render } from "./admin-statistic.vue?vue&type=template&id=65ed804e&scoped=true&ts=true"
import script from "./admin-statistic.vue?vue&type=script&lang=ts"
export * from "./admin-statistic.vue?vue&type=script&lang=ts"

import "./admin-statistic.vue?vue&type=style&index=0&id=65ed804e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ed804e"]])

export default __exports__